// C-4 — Servicio compartido de preferencias de usuario (tabla user_preferences,
// mig 178). Clave→valor JSONB, una fila por (user_id, key). RLS estricta por
// auth.uid() en la BD, así que la lectura NO necesita filtrar por user_id. Único
// punto de lectura/escritura → reutilizable por cualquier pantalla (y por la app
// en C-5, que replicará este mismo contrato contra la misma tabla/clave).

import { supabase } from '../services/supabase';

// Lee el valor de una preferencia del usuario autenticado. `null` si no existe
// (o si hay error de red): quien llama aplica su default.
export async function getUserPreference<T>(key: string): Promise<T | null> {
  const { data, error } = await supabase
    .from('user_preferences')
    .select('value')
    .eq('key', key)
    .limit(1);
  if (error || !data || data.length === 0) return null;
  return (data[0] as { value: T }).value;
}

// Upsert de una preferencia del usuario. `user_id` es obligatorio (la RLS exige
// user_id = auth.uid() en WITH CHECK). Devuelve el mensaje de error o null.
export async function setUserPreference(
  userId: string,
  key: string,
  value: unknown
): Promise<{ error: string | null }> {
  const { error } = await supabase
    .from('user_preferences')
    .upsert({ user_id: userId, key, value }, { onConflict: 'user_id,key' });
  return { error: error ? error.message : null };
}
